<div class="fct-login">

  <!-- ══════════════════════════════════════════
       PANEL IZQUIERDO — Marca
  ══════════════════════════════════════════ -->
  <aside class="fct-brand" aria-hidden="true">
    <div class="fct-aurora">
      <span class="fct-aurora__blob fct-aurora__blob--a"></span>
      <span class="fct-aurora__blob fct-aurora__blob--b"></span>
    </div>
    <div class="fct-brand__dots-hi"></div>

    <div class="fct-brand__inner">

      <!-- Logo + label de producto -->
      <div class="fct-brand__top">
        <img src="/assets/img/brand/handly-logo-lime-white.svg" alt="Handly" class="fct-brand__logo" />
        <span class="fct-brand__label">ERP · GESTIÓN EMPRESARIAL</span>
      </div>

      <!-- Promesa principal -->
      <div class="fct-brand__copy">
        <h1 class="fct-brand__headline">
          <span class="fct-word">Tu</span>&ngsp;<span class="fct-word">gestión,</span><br>
          <span class="fct-hl">
            <span class="fct-word">siempre</span>&ngsp;<span class="fct-word">a</span>&ngsp;<span class="fct-word">mano.</span>
            <svg class="fct-hl__swash" viewBox="0 0 300 18" preserveAspectRatio="none" focusable="false">
              <path d="M3,12 C60,4 120,15 180,8 S270,6 297,10" />
            </svg>
          </span>
        </h1>
        <p class="fct-brand__tagline">
          Facturación, contabilidad, tesorería y equipos en un único espacio de trabajo profesional.
        </p>
      </div>

      <!-- Diagrama de red — todo el negocio conectado en un mismo espacio -->
      <svg class="fct-network" viewBox="0 0 400 150" aria-hidden="true" focusable="false">
        <!-- Malla secundaria — conecta los satélites entre sí -->
        <path class="fct-network__mesh" d="M200,18 L330,75" />
        <path class="fct-network__mesh" d="M330,75 L200,132" />
        <path class="fct-network__mesh" d="M200,132 L70,75" />
        <path class="fct-network__mesh" d="M70,75 L200,18" />

        <!-- Radios principales hub → nodo -->
        <path class="fct-network__line" d="M200,75 L200,18" />
        <path class="fct-network__line" d="M200,75 L330,75" />
        <path class="fct-network__line" d="M200,75 L200,132" />
        <path class="fct-network__line" d="M200,75 L70,75" />

        <!-- Anillos de radar emitidos desde el hub -->
        <circle class="fct-network__ping" cx="200" cy="75" r="14" />
        <circle class="fct-network__ping" cx="200" cy="75" r="14" />
        <circle class="fct-network__ping" cx="200" cy="75" r="14" />

        <!-- Pulsos viajando por cada radio (2 por línea, desfasados) -->
        <circle class="fct-network__pulse" r="3.5" />
        <circle class="fct-network__pulse" r="3.5" />
        <circle class="fct-network__pulse" r="3.5" />
        <circle class="fct-network__pulse" r="3.5" />
        <circle class="fct-network__pulse" r="3.5" />
        <circle class="fct-network__pulse" r="3.5" />
        <circle class="fct-network__pulse" r="3.5" />
        <circle class="fct-network__pulse" r="3.5" />

        <!-- Anillo orbital decorativo, gira sin cesar -->
        <circle class="fct-network__orbit" cx="200" cy="75" r="25" />

        <circle class="fct-network__hub" cx="200" cy="75" r="14" />

        <circle class="fct-network__node" cx="200" cy="18" r="6" />
        <circle class="fct-network__node" cx="330" cy="75" r="6" />
        <circle class="fct-network__node" cx="200" cy="132" r="6" />
        <circle class="fct-network__node" cx="70" cy="75" r="6" />

        <text class="fct-network__label" x="200" y="9">Facturación</text>
        <text class="fct-network__label" x="330" y="98">Tesorería</text>
        <text class="fct-network__label" x="200" y="146">Equipos</text>
        <text class="fct-network__label" x="70" y="98">Contabilidad</text>
      </svg>

      <!-- Widget de producto (prueba visual del valor) -->
      <div class="fct-widget-wrap">
        <div class="fct-widget">
          <div class="fct-widget__head">
            <span class="fct-widget__period">{{ today | date:'MMMM y' }}</span>
            <span class="fct-widget__badge">↑ 12% vs mes anterior</span>
          </div>

          <svg class="fct-widget__chart" viewBox="0 0 240 44" preserveAspectRatio="none" focusable="false">
            <defs>
              <linearGradient id="fct-chart-fill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stop-color="#e3fd64" stop-opacity="0.32" />
                <stop offset="100%" stop-color="#e3fd64" stop-opacity="0" />
              </linearGradient>
            </defs>
            <path class="fct-widget__chart-area"
                  d="M0,38 C18,35 30,30 48,31 S78,22 98,24 S130,15 150,17 S186,9 204,11 S228,4 240,5 L240,44 L0,44 Z" />
            <path class="fct-widget__chart-line"
                  d="M0,38 C18,35 30,30 48,31 S78,22 98,24 S130,15 150,17 S186,9 204,11 S228,4 240,5" />
            <circle class="fct-widget__chart-dot" cx="240" cy="5" r="3" />
          </svg>

          <div class="fct-widget__rows">
            <div class="fct-widget__row">
              <span class="fct-widget__concept">Ingresos facturados</span>
              <span class="fct-widget__amount fct-widget__amount--pos fct-count" data-value="24840">24.840,00 €</span>
            </div>
            <div class="fct-widget__row">
              <span class="fct-widget__concept">Gastos registrados</span>
              <span class="fct-widget__amount fct-widget__amount--neg fct-count" data-value="8120.5">8.120,50 €</span>
            </div>
            <div class="fct-widget__row fct-widget__row--total">
              <span class="fct-widget__concept">Balance neto</span>
              <span class="fct-widget__amount fct-count" data-value="16719.5">16.719,50 €</span>
            </div>
          </div>
          <div class="fct-widget__progress">
            <div class="fct-widget__bar" style="width:67%"></div>
          </div>
          <p class="fct-widget__note">
            <span class="fct-widget__dot"></span>
            3 facturas pendientes de cobro · 1 vence esta semana
          </p>
        </div>

        <!-- Notificaciones flotantes: el producto "vivo" -->
        <div class="fct-toasts">
          <div class="fct-toast">
            <span class="fct-toast__icon fct-toast__icon--ok">
              <svg viewBox="0 0 16 16" fill="none" focusable="false"><path d="M3.5 8.5l3 3 6-7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </span>
            <span class="fct-toast__text"><strong>Factura F-0142 cobrada</strong><small>+1.240,00 € · hace un momento</small></span>
          </div>
          <div class="fct-toast">
            <span class="fct-toast__icon">
              <svg viewBox="0 0 16 16" fill="none" focusable="false"><path d="M2.5 8h9M8.5 4.5L12 8l-3.5 3.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </span>
            <span class="fct-toast__text"><strong>Remesa SEPA enviada</strong><small>18 recibos · 6.420,00 €</small></span>
          </div>
          <div class="fct-toast">
            <span class="fct-toast__icon fct-toast__icon--ok">
              <svg viewBox="0 0 16 16" fill="none" focusable="false"><path d="M8 1.8l5 2v4c0 3-2.1 5.3-5 6.4-2.9-1.1-5-3.4-5-6.4v-4l5-2z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M5.6 8l1.7 1.7L10.6 6.4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </span>
            <span class="fct-toast__text"><strong>VeriFactu aceptado</strong><small>Registro enviado a la AEAT · 0,4 s</small></span>
          </div>
        </div>
      </div>

      <!-- Compliance -->
      <div class="fct-trust">
        <span class="fct-trust__chip">
          <svg viewBox="0 0 16 16" fill="none" focusable="false"><path d="M4 8.5l2.5 2.5L12 5.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
          GDPR
        </span>
        <span class="fct-trust__chip">
          <svg viewBox="0 0 16 16" fill="none" focusable="false"><path d="M4 8.5l2.5 2.5L12 5.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
          TicketBAI
        </span>
        <span class="fct-trust__chip">
          <svg viewBox="0 0 16 16" fill="none" focusable="false"><path d="M4 8.5l2.5 2.5L12 5.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
          VeriFactu
        </span>
      </div>

    </div>
  </aside>


  <!-- ══════════════════════════════════════════
       PANEL DERECHO — Formulario
  ══════════════════════════════════════════ -->
  <main class="fct-form">
    <div class="fct-form__bg" aria-hidden="true">
      <svg class="fct-form__orbits" viewBox="0 0 400 400" focusable="false">
        <circle class="fct-form__orbit" cx="200" cy="200" r="190" />
        <circle class="fct-form__orbit fct-form__orbit--mid" cx="200" cy="200" r="140" />
        <circle class="fct-form__orbit" cx="200" cy="200" r="90" />
        <circle class="fct-form__orbit-node" cx="200" cy="10" r="5" />
        <circle class="fct-form__orbit-node" cx="340" cy="200" r="4" />
        <circle class="fct-form__orbit-node fct-form__orbit-node--solid" cx="136" cy="264" r="4" />
      </svg>
    </div>

    <div class="fct-form__inner">

      <!-- Logo visible solo en mobile -->
      <img src="/assets/img/brand/handly-icon.svg" alt="Handly" class="fct-mobile-logo" />

      <!-- Encabezado del formulario -->
      <header class="fct-form__header">
        <span class="fct-eyebrow">
          <svg viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false">
            <rect x="3" y="7" width="10" height="7" rx="2" stroke="currentColor" stroke-width="1.5"/>
            <path d="M5.5 7V5a2.5 2.5 0 015 0v2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          Conexión segura
        </span>
        <h2 class="fct-form__title">Accede a tu cuenta</h2>
        <p class="fct-form__sub">Bienvenido de nuevo a Handly.</p>
      </header>

      <!-- Error inline -->
      <div class="fct-alert" *ngIf="loginError" role="alert">
        <svg class="fct-alert__icon" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
          <path d="M8 5v3.5M8 10.5v.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        {{ loginError }}
      </div>

      <!-- Campos -->
      <div class="fct-fields">

        <!-- Email -->
        <div class="fct-field-group">
          <label class="fct-label" for="fct-email">Correo electrónico</label>
          <mat-form-field appearance="outline" class="fct-mat-field">
            <input matInput id="fct-email" type="email" name="email"
                   [(ngModel)]="email" autocomplete="email"
                   placeholder="nombre@empresa.com" required />
          </mat-form-field>
        </div>

        <!-- Contraseña -->
        <div class="fct-field-group">
          <div class="fct-field-label-row">
            <label class="fct-label" for="fct-pw">Contraseña</label>
            <button type="button" class="fct-link" (click)="forgot()">
              ¿Olvidaste tu contraseña?
            </button>
          </div>
          <mat-form-field appearance="outline" class="fct-mat-field">
            <input matInput #pwInput id="fct-pw"
                   [type]="showNewPassword ? 'text' : 'password'"
                   name="password" [(ngModel)]="password"
                   autocomplete="current-password" minlength="6"
                   (keyup.enter)="login()" required />
            <button matSuffix mat-icon-button type="button"
                    class="fct-pw-toggle"
                    (click)="showPassword(pwInput)"
                    [attr.aria-label]="showNewPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'">
              <mat-icon>{{ showNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <!-- Recordarme -->
        <label class="fct-remember">
          <input type="checkbox" class="fct-check__input"
                 [(ngModel)]="rememberMe" name="rememberMe" />
          <span class="fct-check__box" aria-hidden="true"></span>
          <span class="fct-check__text">Mantener sesión iniciada</span>
        </label>

      </div>

      <!-- Botón principal -->
      <button type="button"
              class="fct-submit"
              [class.fct-submit--loading]="loginSpinner"
              [disabled]="loginSpinner"
              (click)="login()">
        <ng-container *ngIf="!loginSpinner">
          <span>Entrar en Handly</span>
          <svg class="fct-submit__arrow" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path d="M3 8h10M9 4l4 4-4 4"
                  stroke="currentColor" stroke-width="1.5"
                  stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </ng-container>
        <span class="fct-dots" *ngIf="loginSpinner" aria-label="Cargando">
          <span></span><span></span><span></span>
        </span>
      </button>

      <p class="fct-hint" *ngIf="!loginSpinner">
        o pulsa <kbd>Enter</kbd> desde la contraseña
      </p>

      <!-- Footer del formulario -->
      <footer class="fct-form__footer">
        <p class="fct-register">
          ¿Aún no tienes cuenta?
          <button type="button" class="fct-link fct-link--accent" (click)="register()">
            Regístrate gratis
          </button>
        </p>
        <div class="fct-support">
          <span class="fct-support__label">¿Necesitas ayuda?</span>
          <a class="fct-link" href="mailto:soporte@Handly.com">Soporte técnico</a>
          <span class="fct-trust__sep">·</span>
          <button type="button" class="fct-link" (click)="developers()">Documentación API</button>
        </div>
      </footer>

    </div>
  </main>

</div>
